import { useState } from 'react'
import { Users } from 'lucide-react'
import type { DiscoveryCard as Card } from '@/lib/discoveryApi'
import { guildIconUrl } from '@/lib/avatar'
import { plural } from '@/lib/guildUi'
import { Avatar } from '@/components/Avatar'
import { DiscoveryBanner } from './DiscoveryBanner'
import styles from './DiscoveryPage.module.css'

export function DiscoveryCard({ card, onOpen }: { card: Card; onOpen: () => void }) {
  const [hovered, setHovered] = useState(false)
  return <article className={styles.card} data-banner={card.banner ? '' : undefined} onPointerEnter={e => { if (e.pointerType === 'mouse') setHovered(true) }} onPointerLeave={() => setHovered(false)}>
    <button type="button" className={styles.cardLink} aria-label={`Открыть ${card.name}`} onClick={onOpen} />
    {card.banner ? <DiscoveryBanner key={card.banner} guildId={card.guild_id} hash={card.banner} active={hovered} /> : null}
    <div className={styles.cardContent}>
      <div className={styles.cardIdentity}>
        <Avatar className={styles.cardIcon} initial={card.name.slice(0, 1).toUpperCase()} color="#5865F2" size={56} src={guildIconUrl(card.guild_id, card.icon)} />
        <h2>{card.name}</h2>
      </div>
      <p className={styles.cardDescription}>{card.description}</p>
      <div className={styles.meta}>
        <span><span className={styles.dot} /> {card.approximate_presence_count.toLocaleString('ru-RU')} онлайн</span>
        <span><Users size={13} /> {card.approximate_member_count.toLocaleString('ru-RU')} {plural(card.approximate_member_count, 'участник', 'участника', 'участников')}</span>
      </div>
      {card.tags.length > 0 ? <div className={styles.tags}>{card.tags.map(t => <span key={t}>#{t}</span>)}</div> : null}
    </div>
  </article>
}
